goog.provide('el8.appchart.dialog.ordermed.otc');

goog.require('el8.appchart.dialog.ordermed.rxShared');


el8.appchart.dialog.ordermed.otc = function() {

    return el8.appchart.dialog.ordermed.rxShared('otc', 'OTC');

};
